import InstantOatmealProduct from 'models/InstantOatmealProduct'

export const packagingInitialState = {
  category: InstantOatmealProduct.category,
  subCategory: InstantOatmealProduct.subCategory,
  Kcals: InstantOatmealProduct.Kcals,
  Folate: InstantOatmealProduct.Folate,
  Fiber: InstantOatmealProduct.Fiber,
  WholeGrainCert: InstantOatmealProduct.WholeGrainCert,
  Iron: InstantOatmealProduct.Iron,
  Sucrose: InstantOatmealProduct.Sucrose,
  Rounding: InstantOatmealProduct.Rounding,
  UnderIronLimit: InstantOatmealProduct.UnderIronLimit,
  UnderSucroseLimit: InstantOatmealProduct.UnderSucroseLimit,
  ContainsNoSweeteners: InstantOatmealProduct.ContainsnsNoSweeteners,
  OatType: InstantOatmealProduct.OatType,
  Flavor: InstantOatmealProduct.Flavor,
  Size: InstantOatmealProduct.Size,
}

export const flavorOptions = [
  {
    value: '',
    label: 'Oat Flavor',
    isDisabled: true,
  },
  { value: 'Classic', label: 'Classic' },
  { value: 'Old Fashioned', label: 'Old Fashioned' },
  { value: 'Original', label: 'Original' },
  { value: 'Plain', label: 'Plain' },
  { value: 'Regular', label: 'Regular' },
]
